import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import {SubCategoryProps} from '../types';
import subCategoriesKeys from '../util/sub-categories-keys';
import {CreateSubCategoryProps} from './use-create-sub-category';

export interface EditSubCategoryProps
  extends Omit<CreateSubCategoryProps, 'id' | 'category'> {}

const useEditSubCategory = (subCategoryId: string) => {
  const {update} = useInfiniteQueryHelpers();
  const {setData} = useQueryHelpers();

  const onSuccess = (data: SubCategoryProps) => {
    update(subCategoriesKeys.list(), data);
    setData(subCategoriesKeys.details(subCategoryId), data);
  };

  return useApiMutation<EditSubCategoryProps>({
    url: `/sub-categories/${subCategoryId}`,
    method: 'PATCH',
    errorTitle: 'Erro ao editar sub categoria',
    successTitle: 'Editar sub categoria',
    successMessage: 'Sub categoria atualizada com sucesso',
    onSuccess,
  });
};

export default useEditSubCategory;
